import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";

@Component({
  selector: 'micro-cache',
  templateUrl: './cache.component.html'
})
export class CacheComponent implements OnInit {

  url:string;

  constructor(private env:EnvService) {
  }

  ngOnInit() {
    this.url = `${this.env.e.url}/redis/`;
  }
}
